<template>
  <v-row justify="center">
    <v-dialog v-model="dialogForm" persistent max-width="800px">
      <v-card>
        <v-toolbar color="tertiary" flat>
          <v-toolbar-title class="text-h6">{{ formTitle }}</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
          <v-card-text class="pb-0">
            <v-container fluid>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    label="Nome *"
                    :error-messages="errors.nome"
                    v-model="formData.nome"
                    :counter="255"
                    :rules="rules.nome"
                    outlined
                    dense
                    class="pa-0"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    label="Icone *"
                    :error-messages="errors.icon"
                    v-model="formData.icon"
                    :counter="120"
                    :rules="rules.icon"
                    outlined
                    dense
                    class="pa-0"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    label="Rota *"
                    :error-messages="errors.rota"
                    v-model="formData.rota"
                    :counter="120"
                    :rules="rules.rota"
                    outlined
                    dense
                    class="pa-0"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-autocomplete
                    label="Módulo"
                    v-model="formData.modulo_id"
                    :items="itemsAutoCompleteModulo"
                    :loading="isloadingAutoCompleteModulo"
                    :search-input.sync="searchAutoCompleteModulo"
                    outlined
                    hide-no-data
                    hide-selected
                    item-text="nome"
                    item-value="id"
                    placeholder="Digite no mínimo 3 caracteres"
                    clearable
                    dense
                    :rules="rules.modulo_id"
                    :error-messages="errors.modulo_id"
                    @change="getControladores"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.nome }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.nome }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-autocomplete
                    label="Controlador"
                    v-model="formData.controlador_id"
                    :items="controladores"
                    :loading="isloadingAutoCompleteControlador"
                    outlined
                    hide-no-data
                    hide-selected
                    item-text="nome"
                    item-value="id"
                    placeholder="Digite no mínimo 3 caracteres"
                    clearable
                    dense
                    :rules="rules.controlador_id"
                    :error-messages="errors.controlador_id"
                    @change="getPermissoes"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.nome }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.nome }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-autocomplete
                    label="Permissão"
                    v-model="formData.permissao_id"
                    :items="permissoes"
                    :loading="isloadingAutoCompletePermissao"
                    outlined
                    hide-no-data
                    hide-selected
                    item-text="nome"
                    item-value="id"
                    placeholder="Digite no mínimo 3 caracteres"
                    clearable
                    dense
                    :rules="rules.permissao_id"
                    :error-messages="errors.permissao_id"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.nome }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.nome }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-autocomplete
                    label="Menu"
                    v-model="formData.menu_id"
                    :items="itemsAutoCompleteMenu"
                    :loading="isloadingAutoCompleteMenu"
                    :search-input.sync="searchAutoCompleteMenu"
                    outlined
                    hide-no-data
                    hide-selected
                    item-text="nome"
                    item-value="id"
                    placeholder="Digite no mínimo 3 caracteres"
                    clearable
                    dense
                    :rules="rules.menu_id"
                    :error-messages="errors.menu_id"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.nome }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.nome }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="red" dark
                   depressed
                   @click="toggleForm">
              <v-icon small left>mdi-close</v-icon>
              Fechar
            </v-btn>
            <v-btn
              :disabled="!valid"
              depressed
              :loading="isloadingSubmit"
              color="green" dark
              type="submit">
              <v-icon small left>mdi-send</v-icon>
              Salvar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// Modulo => Controlador => Permissao
import { mapActions, mapState } from 'vuex';
import { max, required } from '@/services/util/validate';
import toastMessage, { toastResponseError } from '@/services/util/alertService';
import moduloHttp from '@/services/http/resources/configuracao/moduloHttp';
import controladorHttp from '@/services/http/resources/configuracao/controladorHttp';
import permissaoHttp from '@/services/http/resources/configuracao/permissaoHttp';
import menuHttp from '@/services/http/resources/configuracao/menuHttp';

export default {
  name: 'MenuModalForm',
  data: () => ({
    valid: true,
    controladores: [],
    permissoes: [],
    formData: {
      id: '',
      nome: '',
      rota: '',
      icon: '',
      modulo_id: '',
      controlador_id: '',
      permissao_id: '',
      menu_id: '',
    },
    formDataDefault: {
      id: '',
      nome: '',
      rota: '',
      icon: '',
      modulo_id: '',
      controlador_id: '',
      permissao_id: '',
      menu_id: '',
    },
    rules: {
      nome: [
        required,
        (value) => max(value, 255),
      ],
      icon: [
        required,
        (value) => max(value, 120),
      ],
      rota: [
        required,
        (value) => max(value, 120),
      ],
      modulo_id: [
        required,
      ],
      permissao_id: [
        required,
      ],
    },
    errors: {
      nome: [],
      icon: [],
      rota: [],
      modulo_id: [],
      permissao_id: [],
    },
    isloadingSubmit: false,
    isloadingAutoCompleteControlador: false,
    isloadingAutoCompletePermissao: false,

    isloadingAutoCompleteModulo: false,
    itemsAutoCompleteModulo: [],
    searchAutoCompleteModulo: '',

    isloadingAutoCompleteMenu: false,
    itemsAutoCompleteMenu: [],
    searchAutoCompleteMenu: '',
  }),
  computed: {
    ...mapState('menu', ['dataIndex', 'data', 'dialogForm']),
    formTitle() {
      return this.dataIndex === -1 ? 'Novo Menu' : 'Editar Menu';
    },
    disabledInput() {
      return !(this.dataIndex === -1);
    },
  },
  methods: {
    ...mapActions('menu', [
      'toggleForm',
      'store',
      'update',
      'setDataIndex',
      'clearData',
    ]),
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isloadingSubmit = true;
        const actionHttp = (this.dataIndex === -1)
          ? this.store(this.formData) : this.update(this.formData);
        actionHttp.then(() => {
          toastMessage.successSave('Menu salvo com sucesso');
          this.resetValidation();
        })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors)
                .forEach(([index, value]) => {
                  this.errors[index].push(value.toString());
                  toastMessage.errorValidation();
                });
            } else {
              toastMessage.errorSave('Erro ao salvar menu');
            }
          })
          .then(() => {
            this.isloadingSubmit = false;
          });
      }
    },
    openDialogForm() {
      this.resetValidation();
      this.resetAutoComplete();
      this.loadModulo();
      this.loadMenu();
      if (this.dataIndex > -1) {
        Object.entries(this.formDataDefault)
          .forEach(([key]) => {
            if (key === 'controlador_id') {
              this.formData[key] = this.data.permissao.controlador_id;
              this.getPermissoes();
            } else if (key === 'modulo_id' && this.data[key]) {
              this.formData[key] = this.data[key];
              this.itemsAutoCompleteModulo.push(this.data.modulo);
              this.getControladores();
            } else if (key === 'permissao_id' && this.data[key]) {
              this.formData[key] = this.data[key];
            } else if (key === 'menu_id' && this.data[key]) {
              this.formData[key] = this.data[key];
              this.itemsAutoCompleteMenu.push(this.data.controller);
            } else {
              this.formData[key] = this.data[key];
            }
          });
      }
    },
    closeDialogForm() {
      setTimeout(() => {
        Object.entries(this.formDataDefault)
          .forEach(([key]) => {
            this.formData[key] = this.formDataDefault[key];
          });
        this.resetValidation();
        this.resetAutoComplete();
        this.clearData();
        this.setDataIndex(-1);
      }, 300);
    },
    loadModulo() {
      this.isloadingAutoCompleteModulo = true;
      moduloHttp.list()
        .then(({ data }) => {
          this.itemsAutoCompleteModulo = data.data;
        })
        .catch((error) => toastResponseError(error))
        .finally(() => {
          this.isloadingAutoCompleteModulo = false;
        });
    },
    loadMenu() {
      this.isloadingAutoCompleteMenu = true;
      menuHttp.list()
        .then(({ data: { data } }) => {
          this.itemsAutoCompleteMenu = data;
        })
        .catch((error) => toastResponseError(error))
        .finally(() => {
          this.isloadingAutoCompleteMenu = false;
        });
    },
    getControladores() {
      if (!this.formData.modulo_id) return;
      this.isloadingAutoCompleteControlador = true;
      controladorHttp.listByModulo(this.formData.modulo_id)
        .then(({ data: { data } }) => {
          this.controladores = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar controladores'))
        .then(() => {
          this.isloadingAutoCompleteControlador = false;
        });
    },
    getPermissoes() {
      if (!this.formData.controlador_id) return;
      this.isloadingAutoCompletePermissao = true;
      permissaoHttp.listByControlador(this.formData.controlador_id)
        .then(({ data: { data } }) => {
          this.permissoes = data;
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar permissões'))
        .then(() => {
          this.isloadingAutoCompletePermissao = false;
        });
    },
    resetAutoComplete() {
      this.permissoes = [];
      this.controladores = [];
      this.itemsAutoCompleteModulo = [];
      this.searchAutoCompleteModulo = null;
      this.itemsAutoCompleteMenu = [];
      this.searchAutoCompleteMenu = null;
    },
  },
  watch: {
    dialogForm(value) {
      if (value) {
        this.openDialogForm();
      } else {
        this.closeDialogForm();
      }
    },
    'formData.nome': function () {
      this.errors.nome = [];
    },
    'formData.icon': function () {
      this.errors.icon = [];
    },
    'formData.rota': function () {
      this.errors.rota = [];
    },
    'formData.controlador_id': function () {
      this.errors.controlador_id = [];
    },
    'formData.modulo_id': function () {
      this.errors.modulo_id = [];
    },
    'formData.permissao_id': function () {
      this.errors.permissao_id = [];
    },
    'formData.menu_id': function () {
      this.errors.menu_id = [];
    },
  },
};
</script>
